import styles from './ProblemsSolvedSummary.module.css';

export const ProblemsSolvedSummaryCard = () => {
  return (
    <div className={styles.problemSolutionSummaryCardRoot}>
      <h3 className={styles.problemSolutionSummaryCardHeading}>One Connected System</h3>
      <p className={styles.problemSolutionSummaryCardText}> SURVEYOR → INSTALLER → COMMAND CENTER</p>
    </div>
  );
};
